export default "__VITE_ASSET__e684f0af__"